import React, { forwardRef, useContext, useMemo } from "react"
import { RESERVATION_KINDS } from "~/constants"
import LineItems from "../../../Reservations/LineItems"
import { NewReservationContext } from "~/contexts/admin/NewReservationContext"
import { AdminContext } from "~/contexts/AdminContext"
import OrderSummary from "../../Orders/OrderSummary"
import { CreateReservationSteps } from "~/constants/NewReservation"
import PaymentMethod from "~/components/Admin/Reservations/NewReservationModal/PaymentMethod"

interface IComponentProps {
  step: CreateReservationSteps
  isCardInputValid: boolean
  setIsCardInputValid: React.Dispatch<React.SetStateAction<boolean>>
}

const CreateReservationOrder = forwardRef(({ step, isCardInputValid, setIsCardInputValid }: IComponentProps, ref) => {
  const {
    order,
    depositPreview,
    isLoadingOrderPreview,
    selectedCampingStyle,
    newReservation,
    isPayingSeparately,
    selectedReservationType,
    recurringKind,
  } = useContext(NewReservationContext)
  const { camp } = useContext(AdminContext)

  if (
    (isLoadingOrderPreview && !order) ||
    !(newReservation?.site_id && newReservation?.start_date && newReservation?.end_date)
  ) {
    return (
      <div
        className={`flex flex-col justify-center items-center w-full ${step === CreateReservationSteps.reservationInfo ? "md:col-span-2" : "lg:col-span-2"
          }`}
      >
        <div className="p-4 rounded-md h-48 flex place-items-center justify-center text-center">
          <div className="text-sm text-gray-700">Please select a site + dates to see camper price information.</div>
        </div>
      </div>
    )
  }

  const isRecurring = useMemo(() => selectedReservationType === RESERVATION_KINDS.RECURRING, [selectedReservationType])

  const taxRateLabel = selectedCampingStyle.tax_rate ? selectedCampingStyle.tax_rate_label : camp.tax_rate ? camp.tax_rate_label : "Tax"

  return (
    <div
      className={`flex flex-col w-full ${step === CreateReservationSteps.reservationInfo ? "md:col-span-2" : "lg:col-span-2"} justify-between px-4 xs:pb-5 sm:py-1`}
    >
      <>
        <div className="flex flex-col justify-between h-full mb-5 gap-2 pt-4">
          <LineItems order={order} camp={camp} />
          <div>
            <OrderSummary
              order={depositPreview ? depositPreview : order}
              camp={camp}
              isPreview
              isLoading={isLoadingOrderPreview}
              newReservationFlow={{ showTitle: true, isRecurring: isRecurring, recurringKind: recurringKind }}
              isDeposit={!!depositPreview}
             
              taxRateLabel={taxRateLabel}
            />
          </div>
        </div>
        {step === CreateReservationSteps.paymentInfo &&
          !(newReservation.kind === RESERVATION_KINDS.GROUP && isPayingSeparately) && (
            <PaymentMethod
              ref={ref}
              selectedCampingStyle={selectedCampingStyle}
              paymentMethod={newReservation.paymentMethod}
              isCardInputValid={isCardInputValid}
              setIsCardInputValid={setIsCardInputValid}
            />
          )}
      </>
    </div>
  )
})

export default CreateReservationOrder
